import './Badge.scss';

import { observer } from 'mobx-react-lite';

type Props = {
  badgeText?: string;
  badgeIcon?: React.ReactNode;
};

export const Badge = observer(({ badgeText, badgeIcon }: Props) => {
  return (
    <div className='badge'>
      {badgeIcon && <span className='badge-icon'>{badgeIcon}</span>}
      <span className='badge-text'>{badgeText}</span>
    </div>
  );
});

export default Badge;
